import { CssBaseline } from "@mui/material";
import DialogProvider from "./DialogProvider";

const AppProvider = ({ children }) => {
  return (
    <DialogProvider>
      <CssBaseline />
      {children}
    </DialogProvider>
  );
};

export default AppProvider;
